import { FormEvent, useState } from "react";
import { IListRoleInProject } from "../../model";
import Input from "../../../../components/Input";
import "./index.scss";
import useAuthData from "../../../../hook/useAppData";
import { toastError } from "../../../../components/Toast";
import { Toaster } from "react-hot-toast";
import { postRoleInProject, putRoleInProject } from "../../service";

export default function FormRoleInProject({ info, exit }: { info?: IListRoleInProject; exit: () => void }) {
  const { token } = useAuthData();
  const [value, setValue] = useState<IListRoleInProject>(info);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    const data = {
      name: value,
    };
    if (info?.id) {
      const res = await putRoleInProject({ body: data, id: info?.id, token });
      if (!res?.ok) return toastError("Não foi possível editar a função");
      return exit();
    }
    const res = await postRoleInProject({ body: data, token });
    if (!res?.ok) return toastError("Não foi possível cadastrar a função");
    return exit();
  }

  return (
    <>
      <Toaster />
      <form onSubmit={handleSubmit} className="modal-form-roleInProject flex center">
        <Input
          name="name"
          label="Nome da Função"
          placeholder="Digite o nome da Função"
          value={value?.name}
          setValue={(e) => setValue(e.target.value)}
        />
        <div className="box-button">
          <button type="submit" className="btn bg-primary">
            {info?.id ? "Editar" : "Adicionar"}
          </button>
        </div>
      </form>
    </>
  );
}
